module.exports = __webpack_public_path__ + "media/exports/required/assets/img/assesscore_logo_test-b6ef81c2c0b5d5436a5421a243e29958.png";